<template>
<!-- 详情里面展示类型 -->
  <div class="atlasItem">
    <component :is="showType" @navClick="navClick" :atlasList="atlasList"/>
  </div>
</template>
<script>
import itemDefault from './components/default'
import itemOne from './components/one'
import itemTwo from './components/two'
export default {
  props:{
    showType:{
      type:String,
      default:'itemDefault'
    },
    atlasList:{
      default:function(){
        return {}
      },
      type:Object
    }
  },
  components:{
    itemDefault,
    itemOne,
    itemTwo
  },
  methods:{
    navClick(item){
      this.$emit('navChange',item)
    }
  }
}
</script>
<style lang="less" scoped>
  .atlasItem{
    // margin-top: 20px;
    margin-bottom: 100px;
  }
</style>